import { render, staticRenderFns } from "./IntegraSantanderImoveis.vue?vue&type=template&id=68087e89"
import script from "./IntegraSantanderImoveis.vue?vue&type=script&lang=js"
export * from "./IntegraSantanderImoveis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports